import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { useCallback, useEffect } from 'react'

import { notify } from '@/api/room'
import useGetRecoilValue from '@/hooks/useGetRecoilValue'
import { paramsState } from '@/store/room'
import uploadClient from '@/utils/upload-client'

import { roomEvent } from '../..'

const cycle = 40

export default function Index() {
  const [params, getParams] = useGetRecoilValue(paramsState)

  useEffect(() => {
    roomEvent.on('roomTime', roomTime)
    return () => {
      roomEvent.removeListener('roomTime', roomTime)
    }
  }, [])

  const roomTime = useCallback((seconds: number, serveTime: number) => {
    teacherImageReport(seconds, serveTime)
  }, [])

  // 高光时刻上报
  const teacherImageReport = async (time: number, serveTime: number) => {
    // const cycle = 15
    if (time % cycle === 0) {
      const videoViceDom = document.querySelector(`#video_viceStudent`) as Element
      const videoMainDom = document.querySelector(`#video_mainStudent`) as Element
      const viceDom = videoViceDom.querySelector('video') as HTMLVideoElement
      const mainDom = videoMainDom.querySelector('video') as HTMLVideoElement
      const videoDom = viceDom || mainDom
      if (!videoDom) {
        return
      }
      const canvas = document.createElement('canvas')
      const context: any = canvas.getContext('2d')
      canvas.width = videoDom.videoWidth
      canvas.height = videoDom.videoHeight
      context.drawImage(videoDom, 0, 0, canvas.width, canvas.height)
      let data = canvas.toDataURL('image/png')
      data = data.split(',')[1]
      data = window.atob(data)
      const ia = new Uint8Array(data.length)
      for (let i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i)
      }
      // 返回 blob 对象
      const blobData = new Blob([ia], {
        type: 'image/png'
      })

      const blobToFile = [new window.File([blobData], 'png', { type: 'image/*' })]
      // 图片如果小于10kb不上传
      if (blobToFile[0].size < 10) {
        console.log('「高光时刻上报」', '图片如果小于10不上传', blobToFile[0].size)
        return
      }
      const picUrl = await new Promise((resolve) => {
        uploadClient.fileUpload(blobToFile).then(async (result: any) => {
          const { picUrl } = result[0]
          resolve(picUrl)
        })
      })
      if (picUrl) {
        // 高光时刻上报
        const data = {
          channelName: params.roomId,
          object: picUrl,
          timestamp: parseInt(`${new Date().getTime() / 1000}`),
          userId: params.mainStudentId
        }
        // console.log('「高光时刻上报」', data)
        notify(data)
          .then(() => {})
          .catch((error) => {
            console.log('-高光时刻上报报错-，', error)
          })
      }
    }
  }

  return <Container></Container>
}

const Container = styled(motion.div)``
